import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
var radioThemeNative = {
  color: 'primary',
  inactive: colors.fogGrey,
  readOnly: colors.octoberGrey,
  disabled: colors.fogGrey,
  fontColor: 'text'
};

var radioDarkThemeNative = _extends({}, radioThemeNative, {
  inactive: colors.octoberGrey,
  readOnly: colors.emperorGrey,
  disabled: colors.emperorGrey
});

var radioThemeWeb = {
  color: 'primary',
  background: 'background',
  label: {
    disabled: colors.fogGrey,
    normal: 'text'
  },
  disabled: {
    borderColor: colors.fogGrey,
    backgroundColor: colors.lightGrey
  },
  unselected: {
    color: colors.fogGrey
  }
};

var radioDarkThemeWeb = _extends({}, radioThemeWeb, {
  label: _extends({}, radioThemeWeb.label, {
    disabled: colors.emperorGrey
  }),
  disabled: _extends({}, radioThemeWeb.disabled, {
    borderColor: colors.emperorGrey,
    backgroundColor: 'background'
  }),
  unselected: {
    color: colors.emperorGrey
  }
});

export { radioDarkThemeNative, radioDarkThemeWeb, radioThemeNative, radioThemeWeb };